var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapQus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3036 1.25318C12.3417 1.25318 13.1833 2.09481 13.1833 3.13288V15.4047L10.7084 12.9298L9.82243 13.8159L13.3669 17.3603C13.6117 17.6049 14.0082 17.6049 14.2529 17.3603L17.7974 13.8159L16.9114 12.9299L14.4365 15.4048V3.13288C14.4343 1.40355 13.033 0.00216103 11.3036 4.57764e-05H8.79736V1.25318H11.3036ZM6.2911 16.2908C5.25288 16.2908 4.4114 15.4493 4.4114 14.4111L4.4114 2.13914L6.88634 4.61404L7.7723 3.72804L4.22785 0.183552C3.9831 -0.0610428 3.5866 -0.0610428 3.34185 0.183552L-0.202637 3.72808L0.683367 4.61408L3.1583 2.13914L3.1583 14.4111C3.16026 16.1404 4.56181 17.5419 6.29114 17.5439H8.7974V16.2908L6.2911 16.2908Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapQus);
export default __webpack_public_path__ + "static/media/swap_qus.2e5935cb1253b8e61d1e2bf3fedf2834.svg";
export { ForwardRef as ReactComponent };